import Vue from 'vue/dist/vue.esm.js'

Vue.component('reports-row-selection-form',
  name: 'reports-row-selection-form'
  props: ['reportPeriod', 'formUrl', 'authToken']
  template: JST['selections/row_selection_form']()
  data: ->
    c81RowNumbers: ''
    b51RowNumbers: ''
    b6RowNumbers: ''
    message: ''

  computed:
    c81Valid: ->
      @checkIfValid @c81RowNumbers

    b51Valid: ->
      @checkIfValid @b51RowNumbers

    b6Valid: ->
      @checkIfValid @b6RowNumbers

    valid: ->
      # All fields valid + at leas one filled
      @b6Valid && @b51Valid && @c81Valid && (@c81RowNumbers || @b51RowNumbers || @b6RowNumbers)

  methods:
    checkIfValid: (string) ->
      validator = new RegExp(/^(\d+\,?)*$/)
      validator.test(string)
)
